import React from 'react';
import Spinner from '@atlaskit/spinner';

import './PageLoader.scss';

const PagerLoader = () => {
  return (
    <div className="page-loader">
      <Spinner size="large" />
    </div>
  );
};

export default PagerLoader;
